import axios from "@/lib/axios";

const getChangePlanRequest = () => {
  return axios.get("/customer/flat_rates/change_plan_request");
}

export default getChangePlanRequest;